import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyber-safety',
  templateUrl: './cyber-safety.component.html',
  styleUrls: ['./cyber-safety.component.scss']
})
export class CyberSafetyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
